import {
  Select,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { UserCompanyDetail } from "@/api/graphql/accounts/getUserCompanies/types";
import { StyledOptionContainer } from "@/components/Users/details/startSessionDrawer/styles";

export const SelectAccount = ({
  listOfCompanies,
  setSelectedAccount,
  selectedAccount,
}: {
  listOfCompanies: UserCompanyDetail[];
  setSelectedAccount: (value: string | null) => void;
  selectedAccount: string | null;
}) => {
  const { t: tUsers } = useTranslation("users");

  const accountsOptions = useMemo(
    () =>
      listOfCompanies?.map((account) => ({
        value: account.accountId ?? "",
        label: (
          <StyledOptionContainer>
            <div>{account.accountNumber}</div>
            <Text variant='sub3'>{account.accountName}</Text>
          </StyledOptionContainer>
        ),
      })),
    [listOfCompanies],
  );

  useEffect(() => {
    setSelectedAccount(accountsOptions[0].value);
  }, []);

  return (
    <Select
      type='options'
      value={selectedAccount ?? ""}
      defaultValue={accountsOptions[0].value}
      onChange={(e) => {
        setSelectedAccount(e.target.value.toString());
      }}
      helperText={tUsers("users.impersonate.drawer.selectAccount.description")}
      label={tUsers("users.impersonate.drawer.selectAccount.placeholder")}
      options={accountsOptions ?? []}
    />
  );
};
